import './PrecheckAlerts.css';

import { Alert, AlertItem } from '@vmware-react/clarity';
import React, { FC } from 'react';

import { AlertGroup } from 'vrlcm-gui-types';
import c from 'classnames';

interface Props {
  alertGroups: AlertGroup[];
}

const PrecheckAlerts: FC<Props> = props => {
  const { alertGroups } = props;
  const hasItems = alertGroups.length > 0;
  return (
    <div className={c('precheck-alerts', { 'has-items': hasItems })}>
      {alertGroups.map((group, index) => {
        return (
          <Alert
            ariaLiveMsg={`${group.items}`}
            items={group.items.map((alertItem, idx) => (
              <AlertItem key={idx}>{alertItem}</AlertItem>
            ))}
            key={index}
            type={group.type}
          />
        );
      })}
    </div>
  );
};

export default PrecheckAlerts;
